/**
 * EliorGroup.Joyfood.Backoffice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreateCustomerModel { 
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    phoneNumber?: string | null;
    employeeId?: string | null;
    unlockCode?: string | null;
    taxId?: string | null;
    terminationDate?: string | null;
    accessCode?: string | null;
    wallet?: string | null;
    role?: number | null;
    companyId?: number;
    siteIds?: Array<number> | null;
}

